<template>
	<div class="skill-list">
		<section v-if="!!skills.length">
			<div
				class="text-uppercase skill-list-header tw-px-6 tw-py-1 tw-flex tw-justify-between tw-mb-4"
			>
				<span>Nombre de competencias</span>
				<span>{{ CHOOSE_LEVEL_MESSAGE() }}</span>
			</div>
			<div class="tw-flex tw-flex-col tw-gap-6">
				<skill-item
					:skill="skill"
					v-for="(skill, index) in skills"
					:key="index"
					@closeClicked="$emit('skillItemRemoveClicked', skill)"
					@chooseLevelClicked="$emit('chooseLevelClicked', skill)"
				></skill-item>
			</div>
		</section>
		<p-empty-message v-if="!skills.length">
			{{ CHOOSE_SKILLS_MESSAGE() }}
		</p-empty-message>
	</div>
</template>
<script>
import SkillItem from './skill-item';
import PEmptyMessage from '../../../../shared/components/ui/p-empty-message';
import { CHOOSE_LEVEL_MESSAGE, CHOOSE_SKILLS_MESSAGE } from '../../../constants/messages.constants';

export default {
	name: 'SkillList',
	methods: {
		CHOOSE_LEVEL_MESSAGE() {
			return CHOOSE_LEVEL_MESSAGE;
		},
		CHOOSE_SKILLS_MESSAGE() {
			return CHOOSE_SKILLS_MESSAGE;
		},
	},
	props: {
		skills: {
			default: () => [],
		},
	},
	components: { PEmptyMessage, SkillItem },
};
</script>

<style lang="scss">
.skill-list {
	.skill-list-header {
		background-color: var(--app-color-primary);
		border-radius: 5px;
		span {
			color: white !important;
		}
	}
	.skill-list-empty {
		padding: 8rem 10px;

		.skill-list-box {
			width: 300px;
			padding: 20px;
			border: 2px dashed #dddddd;
			color: #dddddd;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/three-sixty-evaluation/components/second-step/components/skill-list.vue